// v2/constants/theme.js — tek kaynak: renkler ve olculer
export const COLORS = {
  navy900: '#0B2A5B',
  navy700: '#123E83',
  navy500: '#2563C7',
  accent:  '#2F80ED',
  success: '#16A36A',
  warning: '#F59E0B',
  danger:  '#EF4444',
  bg:      '#F6F8FB',
  card:    '#FFFFFF',
  border:  '#E4E9F2',
  text:    '#0F172A',
  textSub: '#64748B',
  textMuted: '#94A3B8',
};

// Kategori/grafik renkleri (donut, bar)
export const CHART_COLORS = [
  '#0B2A5B', '#2563C7', '#2F80ED', '#5BA3F5', '#7FD1C1', '#CBD5E1',
];

// Stok esikleri: >=25 yesil, >=10 turuncu, altinda kirmizi
export const STOCK_THRESHOLDS = { good: 25, low: 10 };

export const LAYOUT = {
  headerHeight: 72,
  maxWidth: 1800,
  gap: 18,
  radius: 12,
};

export const PAGE_SIZE_OPTIONS = [25, 50, 100];

// tokens.css ile ayni degerler — JS tarafi icin ayna
export const MOTION = {
  fast: 120, base: 180, slow: 280,
  ease: 'cubic-bezier(.2,0,0,1)',
};
